import { render, staticRenderFns } from "./panoramic.vue?vue&type=template&id=140771cf&scoped=true&"
import script from "./panoramic.vue?vue&type=script&lang=js&"
export * from "./panoramic.vue?vue&type=script&lang=js&"
import style0 from "./panoramic.vue?vue&type=style&index=0&id=140771cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140771cf",
  null
  
)

export default component.exports